import LocalizedStrings from 'react-localization';

let localization = new LocalizedStrings({
  id: {
    accepted: "Diterima",
    active: "Aktif",
    addComment: "Beri Komentar",
    addNewEntry: "Tambahkan Data",
    additionalAdvisors: "Pembimbing Lain",
    additionalProspectiveAdvisors: "Calon Pembimbing Lain",
    admins: "Admin",
    adminsList: "Daftar Admin",
    advisingCapacity: "Kapasitas Bimbingan",
    advisor: "Dosen Pembimbing",
    advisorApproval: "Persetujuan Pembimbing",
    advisorConfirmationLetter: "Halaman Pengesahan Dosen Pembimbing",
    advisorsList: "Daftar Dosen",
    advisorLoadStatus: "Status Beban Dosen",
    advisorProfiles: "Profil Pembimbing",
    advisorResearch: "Penelitian Dosen",
    advisors: "Dosen Pembimbing",
    advisorsValidationForms: "Lembar Pengesahan Pembimbing",
    appSubTitle: "Fakultas Teknik Sipil dan Lingkungan - Institut Teknologi Bandung",
    appTitle: "Program Studi Magister Teknik Lingkungan",
    applications: "Aplikasi",
    approved: "Disetujui",
    approved_with_revision: "Disetujui dengan revisi",
    attendees: "Undangan",
    proposal_approved_with_revision: "Masih perlu perbaikan",
    author: "Penulis",
    availableAsAdvisor: "Tersedia Sebagai Pembimbing",
    awaitingApproval: "Menunggu Persetujuan",
    awaitingReview: "Menunggu Review",
    awaitingSubmission: "Menunggu Pengajuan",
    back: "Kembali",
    backToHome: "Kembali ke beranda",
    calendar: "Kalender",
    cancel: "Batal",
    canceled: "Dibatalkan",
    cannotRemoveAcceptedConsultationEntry: "Riwayat bimbingan yang telah diterima tidak dapat dihapus",
    canSubmitUgb: "UGB Dibuka",
    changePassword: "Ubah Password",
    close: "Tutup",
    closed: "Ditutup",
    comment: "Komentar",
    comments: "Komentar",
    commentsHistory: "Riwayat Komentar",
    completed: "Selesai",
    countdown: "Countdown",
    currentPassword: "Password Lama",
    date: "Tanggal",
    days: "hari",
    daysLater: "hari lagi",
    deadline: "Deadline",
    doYouWantToRemoveThisFile: "Apakah Anda ingin menghapus file ini?",
    documentUploadHistory: "Riwayat Upload Dokumen",
    documents: "Dokumen",
    download: "Download",
    downloads: "Download",
    editProfile: "Ubah Profil",
    email: "Email",
    ending: "berakhir",
    examiner: "Dosen Penguji",
    fastTrack: "Fast Track",
    file: "File",
    fileCommentCreationTips: "Tips: Highlight text dengan kursor mouse untuk memberi komentar. Gunakan tombol ALT + mouse drag untuk memilih region (gambar, tabel, dsb).",
    files: "File",
    fillIfExist: "Isi bila ada",
    finalProjectTitle: "Judul TA",
    finalProjectAdvisor: "Pembimbing TA",
    firstSeminar: "Seminar 1",
    firstSeminarPageTitle: "Pengajuan Seminar 1",
    firstSeminarRevisionHistory: "Riwayat Perbaikan Seminar 1",
    firstSeminarSubmissionOpenUntil: "Pengajuan seminar 1 dibuka hingga tanggal",
    firstSeminarSubmissionNotOpen: "Pengajuan seminar 1 belum dibuka",
    first_seminar: "Seminar 1",
    forgotPassword: "Lupa Password?",
    fullName: "Nama Lengkap",
    grading: "Penilaian",
    guardianLecturerVerification: "Verifikasi Dosen Wali",
    hideOlderHistory: "Sembunyikan Riwayat Lama",
    home: "Beranda",
    importantInformation: "Informasi Penting",
    invitation: "Undangan",
    issueReportPanelMessage: "Aplikasi ini sedang dalam tahap pengembangan. Anda dapat melaporkan masalah atau bug langsung ke tim development.",
    journalPublisher: "Nama Jurnal / Prosiding Th. Penerbitan",
    kind: "Jenis",
    lastUpdated: "Update Terakhir",
    lecturer: "Dosen",
    lecturerProfile: "Profil Dosen",
    letterOfSeminarCompletion: "Surat Selesai Seminar",
    links: "Tautan",
    loading: "Loading",
    location: "Tempat",
    login2faMessage: "Kode verifikasi diperlukan demi menjaga keamanan akun anda. Silakan masukkan kode verifikasi yang telah dikirimkan ke alamat email anda.",
    login: "Masuk",
    month: "Bulan",
    name: "Nama",
    newPassword: "Password Baru",
    newPasswordRepeat: "Password Baru (ulangi)",
    nim: "NIM",
    nip: "NIP",
    no: "Tidak",
    noNotesYet: "Belum ada catatan.",
    note: "Catatan",
    numberShort: "No.",
    other: "Lainnya",
    paper: "Makalah",
    paperDraft: "Draft Makalah",
    pleaseCompleteFormBeforeProceeding: "Mohon lengkapi isian form sebelum dapat melanjutkan.",
    phoneNumber: "Nomor Telepon",
    postSeminarRevision: "Revisi Paska Seminar",
    postThesisDefense: "Paska Sidang",
    postThesisDefensePageTitle: "Pelengkapan Dokumen Paska Sidang",
    postThesisDefenseSubmissionOpenUntil: "Pelengkapan Dokumen Paska Sidang dibuka hingga tanggal",
    poster: "Poster",
    presentation: "Presentasi",
    presentationScheduled: "Presentasi Dijadwalkan",
    presentationSlide: "Slide Presentasi",
    presentation_required: "Perlu diperjelas dengan presentasi",
    presentation_thesis_defense: "Sidang",
    presentation_thesis_first_seminar: "Seminar 1",
    presentation_thesis_proposal: "Presentasi Proposal Tesis",
    presentation_thesis_second_seminar: "Seminar 2",
    previewUnsupportedForThisFile: "Preview tidak didukung untuk jenis file ini.",
    program: "Program",
    proposal: "Proposal",
    proposalAccepted: "Proposal Diterima",
    proposalPageTitle: "Pengajuan Proposal",
    proposalStatus: "Status Proposal",
    proposalSubmissionOpenUntil: "Pengajuan proposal dibuka hingga tanggal",
    proposalSubmissionNotOpen: "Pengajuan proposal belum dibuka",
    proposalSubmittedAt: "Proposal Diajukan Tanggal",
    proposalTitle: "Judul Proposal",
    proposer: "Pengusul",
    prospectivePrimaryAdvisor: "Calon Dosen Pembimbing",
    publication: "Publikasi",
    referencedJournal: "Referensi Jurnal Utama",
    rejected: "Ditolak",
    remove: "Hapus",
    removeEntryPrompt: "Hapus konten ini?",
    removeFilePrompt: "Hapus File Ini?",
    removeUserPrompt: "Hapus pengguna ini? Seluruh data akan dihapus secara permanen. Sebaiknya pilih untuk nonaktifkan user ketimbang menghapus agar rekam jejak tidak hilang.",
    required: "Harap diisi.",
    resume: "Resume",
    review: "Review",
    revision: "Perbaikan",
    revision_required: "Perlu direvisi",
    save: "Simpan",
    schedule: "Jadwal",
    scheduled: "Dijadwalkan",
    secondSeminar: "Seminar 2",
    secondSeminarPageTitle: "Pengajuan Seminar 2",
    secondSeminarRevisionHistory: "Riwayat Perbaikan Seminar 2",
    secondSeminarSubmissionOpenUntil: "Pengajuan seminar 2 dibuka hingga tanggal",
    secondSeminarSubmissionNotOpen: "Pengajuan seminar 2 belum dibuka",
    second_seminar: "seminar 2",
    seminarAdmissionLetter: "Upload Surat Pengajuan Seminar",
    seminarApplicationForm: "Surat Pengajuan Seminar",
    seminarExecution: "Pelaksanaan Seminar",
    seminarScore: "Nilai Seminar",
    seminarSubmissionOpenUntil: "Pengajuan seminar dibuka hingga tanggal",
    show: "Tampilkan",
    shownToStudent: "Ditampilkan ke mahasiswa",
    showOlderHistory: "Tampilkan riwayat lama",
    similarity: "Similarity",
    stage: "Tahap",
    status: "Status",
    statusHistory: "Riwayat Status",
    students: "Mahasiswa",
    studentsList: "Daftar Mahasiswa",
    studentThesisProgress: "Progres Status Tesis Mahasiswa",
    subProgram: "Sub Jurusan",
    submission: "Pengajuan",
    submissionApproval: "Submission Approval",
    submissionHasBeenClosedOn: "Pengajuan telah ditutup pada tanggal",
    submissionSent: "Pengajuan Dikirim",
    submit: "Ajukan",
    submitted: "Diajukan",
    templates: "Template",
    test: "Tes Bahasa",
    thesis: "Tesis",
    thesisConsultationNotes: "Catatan Konsultasi Tesis",
    thesisConsultationsHistory: "Riwayat Asistensi Tesis",
    thesisDefense: "Sidang",
    thesisDefenseCompleted: "Sidang Selesai",
    thesisDefenseExecution: "Pelaksanaan Sidang",
    thesisDefensePageTitle: "Pengajuan Sidang",
    thesisDefenseScheduled: "Sidang Dijadwalkan",
    thesisDefenseSubmissionOpenUntil: "Pengajuan sidang dibuka hingga tanggal",
    thesisDefenseSubmissionNotOpen: "Pengajuan sidang belum dibuka",
    thesisDefenseSubmissionStatus: "Status Pengajuan Sidang",
    thesisDiscussedWith: "Tesis didiskusikan dengan",
    thesisDraft: "Draft Tesis",
    thesisPageTitle: "Penyusunan Tesis",
    thesisProgress: "Penyelesaian Tesis",
    thesisSchedule: "Jadwal Tesis",
    thesisStage: "Tahapan Tesis",
    thesisStatus: "Status Tesis",
    thesisSubmissionOpenUntil: "Penyusunan tesis dibuka hingga tanggal",
    thesisSubmissionNotOpen: "Pengajuan progres tesis belum dibuka",
    thesisTitle: "Judul Tesis",
    thesisUploadMessage: "Upload file tesis terbaru untuk memudahkan proses bimbingan dengan dosen pembimbing anda.",
    thesisWriting: "Penyusunan Tesis",
    thesis_defense: "Sidang",
    thesis_writing: "Penyusunan Thesis",
    title: "Judul",
    transcript: "Transkrip",
    type: "Jenis",
    ugb: "UGB",
    ugbAccepted: "UGB Diterima",
    ugbEdit: "Edit UGB",
    ugbPageTitle: "Pengajuan Usulan Garis Besar (UGB)",
    ugbReview: "Review UGB",
    ugbStatus: "Status UGB",
    ugbSubmissionOpenUntil: "Pengajuan UGB dibuka hingga tanggal",
    ugbSubmittedAt: "UGB Diajukan Tanggal",
    ugbTitle: "Judul UGB",
    undergraduateBackground: "Latar Belakang S1",
    university: "Perguruan Tinggi",
    universityProgram: "Program Studi",
    updateData: "Update Data",
    uploadedBy: "Diunggah oleh",
    uploadAdvisorApproval: "Upload Bukti Persetujuan Pembimbing",
    uploadAdvisorsValidationForms: "Upload Lembar Pengesahan Pembimbing",
    uploadKTM: "Upload KTM Terbaru",
    uploadKSM: "Upload KSM Terbaru",
    uploadLatestThesisFiles: "Upload File Tesis Terbaru",
    uploadLetter: "Upload Surat",
    uploadPaper: "Upload Makalah",
    uploadProposal: "Upload Proposal",
    uploadReferencedJournal: "Upload Jurnal Utama",
    uploadResume: "Upload Resume",
    uploadSeminarApplicationForm: "Upload Surat Pengajuan Seminar",
    uploadThesis: "Upload Tesis",
    uploadThesisConsultationNotes: "Upload Catatan Konsultasi Tesis",
    uploadTranscript: "Upload Transkrip Terbaru",
    uploadUGB: "Upload UGB",
    userManagement: "User Management",
    verificationCode: "Kode Verifikasi",
    verifiedByAdvisor: "Verifikasi Pembimbing",
    writing: "Dalam Penyusunan",
    yes: "Ya",
  },
  "en-us": {
    accepted: "Accepted",
    active: "Active",
    addComment: "Add Comment",
    addNewEntry: "Add New Entry",
    additionalAdvisors: "Additional Advisors",
    additionalProspectiveAdvisors: "Additional Prospective Advisors",
    admins: "Admins",
    adminsList: "Admins List",
    advisingCapacity: "Advisor Capacity",
    advisor: "Advisor",
    advisorApproval: "Advisor Approval",
    advisorConfirmationLetter: "Advisor Confirmation Letter",
    advisorsList: "Advisors List",
    advisorLoadStatus: "Advisors Load Status",
    advisorProfiles: "Advisor Profiles",
    advisorResearch: "Advisor Research",
    advisors: "Advisors",
    advisorsValidationForms: "Advisors Validation Forms",
    appSubTitle: "Fakultas Teknik Sipil dan Lingkungan - Institut Teknologi Bandung",
    appTitle: "Environmental Engineering Master Program",
    applications: "Applications",
    approved: "Approved",
    approved_with_revision: "Approved with revision",
    attendees: "Attendees",
    proposal_approved_with_revision: "Need revision",
    author: "Author",
    availableAsAdvisor: "Available as Advisor",
    awaitingApproval: "Awaiting Approval",
    awaitingReview: "Awaiting Review",
    awaitingSubmission: "Awaiting Submission",
    back: "Back",
    backToHome: "Back to home",
    calendar: "Calendar",
    cancel: "Cancel",
    canceled: "Canceled",
    cannotRemoveAcceptedConsultationEntry: "Cannot remove accepted consultation entry",
    canSubmitUgb: "Can Submit UGB",
    changePassword: "Change Password",
    close: "Close",
    closed: "Closed",
    comment: "Comment",
    comments: "Comments",
    commentsHistory: "Comments History",
    completed: "Completed",
    countdown: "Countdown",
    currentPassword: "Current Password",
    date: "Date",
    days: "days",
    daysLater: "days later",
    deadline: "Deadline",
    doYouWantToRemoveThisFile: "Do you want to remove this file?",
    documentUploadHistory: "Document Upload History",
    documents: "Documents",
    download: "Download",
    downloads: "Downloads",
    editProfile: "Edit Profile",
    email: "Email",
    ending: "ending",
    examiner: "Examiner",
    fastTrack: "Fast Track",
    file: "File",
    fileCommentCreationTips: "Tips: Highlight text with the mouse cursor to attach a comment. Use ALT + mouse drag to select a region (pictures, tables, etc).",
    files: "Files",
    fillIfExist: "Fill if exist",
    finalProjectTitle: "Final Project Title",
    finalProjectAdvisor: "Final Project Advisor",
    firstSeminar: "First Seminar",
    firstSeminarPageTitle: "First Seminar Submission",
    firstSeminarRevisionHistory: "First Seminar Revision History",
    firstSeminarSubmissionOpenUntil: "First seminar submission is open until",
    firstSeminarSubmissionNotOpen: "First seminar submission is not open yet",
    first_seminar: "First seminar",
    forgotPassword: "Forgot Password?",
    fullName: "Full Name",
    grading: "Grading",
    guardianLecturerVerification: "Guardian Lecturer Verification",
    hideOlderHistory: "Hide Older History",
    home: "Home",
    importantInformation: "Important Information",
    invitation: "Invitation",
    issueReportPanelMessage: "This application is currently under active development. Please report any issue or bug directly to the development team.",
    journalPublisher: "Journal / Publisher",
    kind: "Kind",
    lastUpdated: "Last Updated",
    lecturer: "Lecturer",
    lecturerProfile: "Lecturer Profile",
    letterOfSeminarCompletion: "letter of Seminar Completion",
    links: "Links",
    loading: "Loading",
    location: "Location",
    login2faMessage: "For your account security, please enter a one-time verification code. The verification code has been sent to your email address.",
    login: "Login",
    month: "Month",
    name: "Name",
    newPassword: "New Password",
    newPasswordRepeat: "New Password (repeat)",
    nim: "NIM",
    nip: "NIP",
    no: "No",
    noNotesYet: "No notes yet.",
    note: "Note",
    numberShort: "No.",
    other: "Other",
    paper: "Journal",
    paperDraft: "Journal Draft",
    pleaseCompleteFormBeforeProceeding: "Please complete this form before proceeding.",
    phoneNumber: "Phone Number",
    postSeminarRevision: "Post Seminar Revision",
    postThesisDefense: "Post Thesis Defense",
    postThesisDefensePageTitle: "Post Thesis Defense Documents Submission",
    postThesisDefenseSubmissionOpenUntil: "Post Thesis Defense Documents Submission is open until",
    poster: "Poster",
    presentation: "Presentation",
    presentationScheduled: "Presentation Scheduled",
    presentationSlide: "Presentation Slide",
    presentation_required: "Presentation required",
    presentation_thesis_defense: "Thesis Defense",
    presentation_thesis_first_seminar: "First Seminar",
    presentation_thesis_proposal: "Thesis Proposal Presentation",
    presentation_thesis_second_seminar: "Second Seminar",
    previewUnsupportedForThisFile: "Preview is unsupported for this file type.",
    program: "Program",
    proposal: "Proposal",
    proposalAccepted: "Proposal Accepted",
    proposalPageTitle: "Proposal Submission",
    proposalStatus: "Proposal Status",
    proposalSubmissionOpenUntil: "Proposal submission is open until",
    proposalSubmissionNotOpen: "Proposal submission is not open yet",
    proposalSubmittedAt: "Proposal Submitted at",
    proposalTitle: "Proposal Title",
    proposer: "Proposer",
    prospectivePrimaryAdvisor: "Prospective Advisor",
    publication: "Publication",
    referencedJournal: "Referenced Journal",
    rejected: "Rejected",
    remove: "Remove",
    removeEntryPrompt: "Remove this entry?",
    removeFilePrompt: "Remove This File?",
    removeUserPrompt: "Remove this user? All data will be permanently removed. It is better to deactivate the user instead of removing it to preserve activity logs.",
    required: "This field is required.",
    resume: "Resume",
    review: "Review",
    revision: "Revision",
    revision_required: "Revision Required",
    save: "Save",
    schedule: "Schedule",
    scheduled: "Sceduled",
    secondSeminar: "Second Seminar",
    secondSeminarPageTitle: "Second Seminar Submission",
    secondSeminarRevisionHistory: "Second Seminar Revision History",
    secondSeminarSubmissionOpenUntil: "Second seminar submission is open until",
    secondSeminarSubmissionNotOpen: "Second seminar submission is not open yet",
    second_seminar: "Second Seminar",
    seminarAdmissionLetter: "Upload Seminar Admission Letter",
    seminarApplicationForm: "Seminar Application Form",
    seminarExecution: "Seminar Execution",
    seminarScore: "Seminar Score",
    seminarSubmissionOpenUntil: "Seminar submission is open until",
    show: "Show",
    shownToStudent: "Shown to student",
    showOlderHistory: "Show Older History",
    similarity: "Similarity",
    stage: "Stage",
    status: "Status",
    statusHistory: "Status History",
    students: "Students",
    studentsList: "Students List",
    studentThesisProgress: "Students Thesis Progress",
    subProgram: "Sub Program",
    submission: "Submission",
    submissionApproval: "Submission Approval",
    submissionHasBeenClosedOn: "Submission has been closed on",
    submissionSent: "Submission Sent",
    submit: "Submit",
    submitted: "Submitted",
    templates: "Templates",
    test: "Language Test",
    thesis: "Thesis",
    thesisConsultationNotes: "Thesis Consultation Notes",
    thesisConsultationsHistory: "Thesis Consultations History",
    thesisDefense: "Thesis Defense",
    thesisDefenseCompleted: "Thesis Defense Completed",
    thesisDefenseExecution: "Thesis Defense Execution",
    thesisDefensePageTitle: "Thesis Defense Submission",
    thesisDefenseScheduled: "Thesis Defense Scheduled",
    thesisDefenseSubmissionOpenUntil: "Thesis defense submission is open until",
    thesisDefenseSubmissionNotOpen: "Thesis defense submission is not open yet",
    thesisDefenseSubmissionStatus: "Thesis Defense Submission Status",
    thesisDiscussedWith: "Tesis discussed with",
    thesisDraft: "Thesis Draft",
    thesisPageTitle: "Thesis Writing",
    thesisProgress: "Thesis Progress",
    thesisSchedule: "Thesis Schedule",
    thesisStage: "Thesis Stage",
    thesisStatus: "Thesis Status",
    thesisSubmissionOpenUntil: "Thesis submission is open until",
    thesisSubmissionNotOpen: "Thesis files submission is not open yet",
    thesisTitle: "Thesis Title",
    thesisUploadMessage: "Upload your latest thesis document here to allow your advisors to review your progress.",
    thesisWriting: "Thesis Writing",
    thesis_defense: "Thesis Defense",
    thesis_writing: "Thesis Writing",
    title: "Title",
    transcript: "Transcript",
    type: "Type",
    ugb: "UGB",
    ugbAccepted: "UGB Accepted",
    ugbEdit: "UGB Edit",
    ugbPageTitle: "UGB Submission",
    ugbReview: "UGB Review",
    ugbStatus: "UGB Status",
    ugbSubmissionOpenUntil: "UGB submission is open until",
    ugbSubmittedAt: "UGB submitted at",
    ugbTitle: "UGB Title",
    undergraduateBackground: "Undergraduate Backgroud",
    university: "University",
    universityProgram: "Program",
    updateData: "Update Data",
    uploadedBy: "Uploaded by",
    uploadAdvisorApproval: "Upload Advisor Approval",
    uploadAdvisorsValidationForms: "Upload Advisors Validation Forms",
    uploadKTM: "Upload Latest KTM",
    uploadKSM: "Upload Latest KSM",
    uploadLatestThesisFiles: "Upload Latest Thesis Documents",
    uploadLetter: "Upload Letter",
    uploadPaper: "Upload Paper",
    uploadProposal: "Upload Your Proposal",
    uploadReferencedJournal: "Upload Referenced Jurnal",
    uploadResume: "Upload Resume",
    uploadSeminarApplicationForm: "Upload Seminar Application Form",
    uploadThesis: "Upload Your Thesis",
    uploadThesisConsultationNotes: "Upload Thesis Consultation Notes",
    uploadTranscript: "Upload Latest Transcript",
    uploadUGB: "Upload Your UGB",
    userManagement: "User Management",
    verificationCode: "Verification Code",
    verifiedByAdvisor: "Verified by Advisor",
    writing: "Writing",
    yes: "Yes",
  }
});

export default localization;
